// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__3aQEc","icon":"Tag_icon__7OGIe","text":"Tag_text__Q21XA","slide-in-out":"Tag_slide-in-out__4L_Y6","fade-in-out":"Tag_fade-in-out__2YRKA"};